import { render } from "./Index.vue?vue&type=template&id=862a997e&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=862a997e&lang=css"
import "./Index.vue?vue&type=style&index=1&id=862a997e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-862a997e"],['__file',"components/Vendors/Calendar/v2/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "862a997e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('862a997e', __exports__)) {
    api.reload('862a997e', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=862a997e&scoped=true", () => {
    api.rerender('862a997e', render)
  })

}


export default __exports__